import { ADD_QUIZ_ENTRIES, ADD_QUIZ_ENTRY, DELETE_QUIZ_ENTRY, DELETE_STIMULUS_ENTRY, MOVE_QUIZ_ENTRY, UPDATE_SAMPLE_ITEMS } from '@instructure/quiz-common';
export function addQuizEntries(quizEntries) {
  return {
    type: ADD_QUIZ_ENTRIES,
    payload: quizEntries
  };
}
export function addQuizEntry(quizEntry) {
  return {
    type: ADD_QUIZ_ENTRY,
    payload: quizEntry
  };
}
export function deleteQuizEntry(id) {
  return {
    type: DELETE_QUIZ_ENTRY,
    payload: {
      id: id
    }
  };
}
export function deleteStimulusEntry(id, childQuizEntryIds) {
  return {
    type: DELETE_STIMULUS_ENTRY,
    payload: {
      id: id,
      childQuizEntryIds: childQuizEntryIds
    }
  };
}
export function moveQuizEntry(id, position, stimulusQuizEntryId) {
  return {
    type: MOVE_QUIZ_ENTRY,
    payload: {
      id: id,
      position: position,
      stimulusQuizEntryId: stimulusQuizEntryId
    }
  };
}
export function updateSampleItems(id, sampleItems) {
  return {
    type: UPDATE_SAMPLE_ITEMS,
    payload: {
      id: id,
      sampleItems: sampleItems
    }
  };
}